export default __webpack_public_path__ + "static/media/221111_squremeasure.8142eb71.pdf";